import BaseModel from './BaseModel'
import {currentConseillerId} from '@/helpers'

export default class PropositionModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      ID_PROSPECT: null,
      ID_CONSEILLER: currentConseillerId(),
      CODE_REF_OFFRE: 'A',
      PROPOSITION_SECRETARIAT: 0,
      PROPOSITION_EMPLOYES: 0,
      PROPOSITION_COACHING: 0,
      PROPOSITION_AUDIT: 0,
      PROPOSITION_DEMARRAGE: 0,
      PROPOSITION_TARIF_UNITAIRE: '',
      PROPOSITION_TENUE_ASSEMBLEES: 0,
      PROPOSITION_CS_TARIF_PREMIERE_ANNEE: 0,
      VERSION_TARIF: 2,
      TARIF_NEGOCIE: 0,
      CODE_REF_TYPE_REMISE: 'U',
      TARIF_REMISE_UNITAIRE: '',
      TARIF_REMISE_GLOBAL: '',
      TARIF_REMISE_GLOBAL_PREMIERE_ANNEE: 0,
      TEXTE_LIBRE: '',
      DATE_ENVOI_COMMANDE: '',
      DATE_RECEPTION_COMMANDE: '',
      ANNULEE: 0,
      COMMENTAIRES: '',
      DATE_VALIDITE: '',
      OPTIONS: null
    }
    super(data, relation, fields)
  }
}
